/**
 * Engine of user's requests about time, status, search term, etc
 */

async function TwpRefinebarController($scope) {
  $scope.tab = 1;
}


const ctrlArr = [
  '$scope',
  TwpRefinebarController
];

export default function (ngModule) {
  ngModule.controller('TwpRefinebarController', ctrlArr);
}
